import { AbstractValidator } from './abstract-validator';

export class StringLengthValidator extends AbstractValidator {
    static getIdentifier() {
        return 'string-length';
    }
    static isApplicable(input) {
        return super.isApplicable(input)
            && (input.tagName === 'TEXTAREA'
                || (input.tagName === 'INPUT'
                    && input.getAttribute('type') !== 'checkbox'
                    && input.getAttribute('type') !== 'radio'
                )
            );
    }

    /**
     * @param {HTMLInputElement|HTMLTextAreaElement} input
     */
    static validate(input) {
        return (onError, onSuccess) => {
            let min = input.getAttribute('minlength');
            let max = input.getAttribute('maxlength');
            const args = {};
            const value = input.value;
            let valid = true;
            if (min !== null) {
                min = Number.parseInt(min);
                if (!Number.isNaN(min)) {
                    args.min = min;
                    if (value.length < min) {
                        valid = false;
                    }
                }
            }
            if (max !== null) {
                max = Number.parseInt(max);
                if (!Number.isNaN(max)) {
                    args.max = max;
                    if (value.length > max) {
                        valid = false;
                    }
                }
            }
            if (!valid && value !== '') {
                onError(args);
            } else {
                onSuccess(args);
            }
        };
    }
}